module.exports = __webpack_public_path__ + "overview-a5b6df21/bookmark-fill-11b369d6509a29726ee252f4b4411967.svg";